// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================
   CSS Custom Properties / Design Tokens
   ======================================== */
:root {
  --bg-primary: #0a0f1e;
  --bg-secondary: #0f172a;
  --bg-card: rgba(15, 23, 42, 0.8);
  --bg-glass: rgba(255, 255, 255, 0.05);
  --bg-glass-hover: rgba(255, 255, 255, 0.08);

  --brand-primary: #6366f1;
  --brand-secondary: #8b5cf6;
  --brand-accent: #06b6d4;
  --brand-pink: #ec4899;
  --brand-green: #10b981;
  --brand-yellow: #f59e0b;
  --brand-red: #ef4444;

  --text-primary: #f1f5f9;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;

  --border-color: rgba(255, 255, 255, 0.08);
  --border-card: rgba(99, 102, 241, 0.2);

  --gradient-primary: linear-gradient(135deg, #6366f1, #8b5cf6);
  --gradient-cool: linear-gradient(135deg, #06b6d4, #6366f1);
  --gradient-warm: linear-gradient(135deg, #f59e0b, #ef4444);
  --gradient-green: linear-gradient(135deg, #10b981, #06b6d4);

  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 20px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 8px 40px rgba(0, 0, 0, 0.5);
  --shadow-glow: 0 0 30px rgba(99, 102, 241, 0.3);

  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;

  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  --font-main: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
}

/* ========================================
   Reset & Base
   ======================================== */
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html { scroll-behavior: smooth; -webkit-text-size-adjust: 100%; overflow-x: hidden; }
body {
  font-family: var(--font-main);
  background: var(--bg-primary);
  color: var(--text-primary);
  line-height: 1.6;
  min-height: 100vh;
  overflow-x: hidden;
}
a { color: inherit; text-decoration: none; }
button { cursor: pointer; font-family: inherit; border: none; outline: none; }
input, textarea, select {
  font-family: inherit;
  outline: none;
  border: none;
}
img { max-width: 100%; height: auto; }
ul { list-style: none; }

/* Scrollbar */
::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-track { background: var(--bg-secondary); }
::-webkit-scrollbar-thumb { background: var(--brand-primary); border-radius: 3px; }

/* ========================================
   Utility Classes
   ======================================== */
.container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }
.section { padding: 100px 0; }
.section-sm { padding: 60px 0; }
.text-center { text-align: center; }
.text-gradient {
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.text-gradient-cool {
  background: var(--gradient-cool);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ========================================
   Buttons
   ======================================== */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: 600;
  transition: var(--transition);
  white-space: nowrap;
}
.btn-primary {
  background: var(--gradient-primary);
  color: #fff;
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);
}
.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 35px rgba(99, 102, 241, 0.6);
}
.btn-secondary {
  background: transparent;
  border: 1px solid var(--brand-primary);
  color: var(--brand-primary);
}
.btn-secondary:hover {
  background: rgba(99, 102, 241, 0.1);
  transform: translateY(-2px);
}
.btn-ghost {
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  backdrop-filter: blur(10px);
}
.btn-ghost:hover { background: var(--bg-glass-hover); }
.btn-danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #fff;
}
.btn-danger:hover { transform: translateY(-2px); opacity: 0.9; }
.btn-sm { padding: 8px 16px; font-size: 13px; }
.btn-lg { padding: 16px 40px; font-size: 17px; }

/* ========================================
   Glass Cards
   ======================================== */
.glass-card {
  background: var(--bg-glass);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 28px;
  transition: var(--transition);
}
.glass-card:hover {
  background: var(--bg-glass-hover);
  border-color: var(--border-card);
  transform: translateY(-4px);
  box-shadow: var(--shadow-glow);
}

/* ========================================
   Typography
   ======================================== */
.section-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin-bottom: 16px;
}
.section-subtitle {
  font-size: 18px;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto 60px;
  line-height: 1.7;
}
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(99, 102, 241, 0.15);
  border: 1px solid rgba(99, 102, 241, 0.3);
  color: var(--brand-primary);
  padding: 6px 14px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  margin-bottom: 20px;
}

/* ========================================
   Forms
   ======================================== */
.form-group { margin-bottom: 20px; }
.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  margin-bottom: 8px;
}
.form-control {
  width: 100%;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 15px;
  transition: var(--transition);
}
.form-control:focus {
  border-color: var(--brand-primary);
  background: rgba(99, 102, 241, 0.08);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}
.form-control::placeholder { color: var(--text-muted); }
.form-control option { background: var(--bg-secondary); color: var(--text-primary); }
textarea.form-control { resize: vertical; min-height: 120px; }

/* ========================================
   Status Badges
   ======================================== */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.status-open { background: rgba(59, 130, 246, 0.15); color: #60a5fa; border: 1px solid rgba(59, 130, 246, 0.3); }
.status-in_progress { background: rgba(245, 158, 11, 0.15); color: #fbbf24; border: 1px solid rgba(245, 158, 11, 0.3); }
.status-resolved { background: rgba(16, 185, 129, 0.15); color: #34d399; border: 1px solid rgba(16, 185, 129, 0.3); }
.status-closed { background: rgba(107, 114, 128, 0.15); color: #9ca3af; border: 1px solid rgba(107, 114, 128, 0.3); }

.priority-low { color: #34d399; }
.priority-medium { color: #fbbf24; }
.priority-high { color: #f87171; }
.priority-urgent { color: #ef4444; }

/* ========================================
   Navbar
   ======================================== */
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 16px 0;
  transition: var(--transition);
}
.navbar.scrolled {
  background: rgba(10, 15, 30, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border-color);
  padding: 12px 0;
}
.navbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.navbar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;
  font-weight: 800;
}
.logo-icon {
  width: 38px;
  height: 38px;
  background: var(--gradient-primary);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.navbar-links { display: flex; align-items: center; gap: 8px; }
.navbar-links a {
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
}
.navbar-links a:hover, .navbar-links a.active { color: var(--text-primary); background: var(--bg-glass); }
.navbar-actions { display: flex; align-items: center; gap: 12px; }
.hamburger-btn { display: none; background: var(--bg-glass); border: 1px solid var(--border-color); color: var(--text-primary); padding: 8px 12px; border-radius: var(--radius-sm); font-size: 18px; }

/* ========================================
   Hero
   ======================================== */
.hero {
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding-top: 80px;
  position: relative;
  overflow: hidden;
}
.hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.hero-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.15;
}
.hero-orb-1 { width: 600px; height: 600px; background: var(--brand-primary); top: -200px; right: -100px; }
.hero-orb-2 { width: 400px; height: 400px; background: var(--brand-secondary); bottom: -100px; left: -100px; }
.hero-orb-3 { width: 300px; height: 300px; background: var(--brand-accent); top: 50%; left: 40%; }
.hero-content { position: relative; z-index: 1; max-width: 800px; }
.hero-title {
  font-size: clamp(2.5rem, 6vw, 4.5rem);
  font-weight: 900;
  line-height: 1.1;
  letter-spacing: -0.03em;
  margin-bottom: 24px;
}
.hero-subtitle {
  font-size: clamp(16px, 2vw, 20px);
  color: var(--text-secondary);
  line-height: 1.7;
  margin-bottom: 40px;
  max-width: 600px;
}
.hero-actions { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 60px; }
.hero-stats { display: flex; gap: 40px; }
.stat-item { text-align: left; }
.stat-number { font-size: 28px; font-weight: 800; background: var(--gradient-primary); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
.stat-label { font-size: 13px; color: var(--text-muted); margin-top: 2px; }

/* ========================================
   Tools Grid
   ======================================== */
.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 16px;
  margin-top: 60px;
  width: 100%;
  overflow: hidden;
}
.tool-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 16px;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  cursor: pointer;
  transition: var(--transition);
  text-align: center;
}
.tool-card:hover {
  background: var(--bg-glass-hover);
  border-color: var(--border-card);
  transform: translateY(-6px);
  box-shadow: var(--shadow-glow);
}
.tool-icon { font-size: 40px; }
.tool-name { font-size: 13px; font-weight: 600; color: var(--text-secondary); }

/* ========================================
   How It Works
   ======================================== */
.steps-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 24px; margin-top: 60px; }
.step-card {
  text-align: center;
  padding: 36px 24px;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  position: relative;
  overflow: hidden;
  transition: var(--transition);
}
.step-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: var(--gradient-primary);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}
.step-card:hover::before { transform: scaleX(1); }
.step-card:hover { transform: translateY(-6px); box-shadow: var(--shadow-glow); }
.step-number {
  width: 56px; height: 56px;
  display: flex; align-items: center; justify-content: center;
  background: var(--gradient-primary);
  border-radius: 50%;
  font-size: 22px; font-weight: 800;
  margin: 0 auto 20px;
  box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);
}
.step-card h3 { font-size: 18px; font-weight: 700; margin-bottom: 12px; }
.step-card p { color: var(--text-secondary); font-size: 14px; line-height: 1.7; }

/* ========================================
   Pricing
   ======================================== */
.pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; margin-top: 60px; }
.pricing-card {
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  padding: 24px;
  position: relative;
  transition: var(--transition);
  overflow: visible;
}
.pricing-card:hover, .pricing-card.featured {
  border-color: var(--brand-primary);
  transform: translateY(-8px);
  box-shadow: var(--shadow-glow);
}
.pricing-card.featured {
  background: linear-gradient(145deg, rgba(99,102,241,0.1), rgba(139,92,246,0.1));
}
.featured-badge {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--gradient-primary);
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 12px; 
  font-weight: 700;
  white-space: nowrap;
  box-shadow: var(--shadow-md);
  z-index: 10;
}
.plan-name { font-size: 22px; font-weight: 700; margin-bottom: 8px; }
.plan-desc { color: var(--text-secondary); font-size: 14px; margin-bottom: 24px; }
.plan-price { margin-bottom: 28px; }
.price-amount { font-size: 48px; font-weight: 900; line-height: 1; }
.price-currency { font-size: 24px; vertical-align: top; margin-top: 8px; display: inline-block; }
.price-period { color: var(--text-muted); font-size: 14px; margin-top: 4px; }
.plan-features { list-style: none; margin-bottom: 32px; }
.plan-features li {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-color);
  font-size: 14px; color: var(--text-secondary);
}
.plan-features li:last-child { border: none; }
.feature-check { color: var(--brand-green); font-size: 16px; flex-shrink: 0; }

/* ========================================
   Testimonials
   ======================================== */
.testimonials-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; margin-top: 60px; }
.testimonial-card {
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 32px;
  transition: var(--transition);
}
.testimonial-card:hover { transform: translateY(-4px); border-color: var(--border-card); }
.stars { color: #fbbf24; font-size: 16px; margin-bottom: 16px; letter-spacing: 2px; }
.testimonial-text { color: var(--text-secondary); font-size: 15px; line-height: 1.8; margin-bottom: 24px; font-style: italic; }
.testimonial-author { display: flex; align-items: center; gap: 14px; }
.author-avatar {
  width: 44px; height: 44px;
  background: var(--gradient-primary);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 16px;
}
.author-name { font-weight: 600; font-size: 15px; }
.author-role { color: var(--text-muted); font-size: 13px; }

/* ========================================
   Dashboard Layout
   ======================================== */
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  padding-top: 0;
}
.sidebar {
  width: 260px;
  min-height: 100vh;
  background: var(--bg-secondary);
  border-right: 1px solid var(--border-color);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease;
}
.sidebar-logo {
  padding: 24px 20px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 800;
}
.sidebar-nav { padding: 20px 12px; flex: 1 1; }
.sidebar-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: var(--radius-md);
  color: var(--text-muted);
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
  cursor: pointer;
  margin-bottom: 4px;
  width: 100%;
  background: transparent;
  text-align: left;
}
.sidebar-nav-item:hover { background: var(--bg-glass); color: var(--text-primary); }
.sidebar-nav-item.active { background: rgba(99, 102, 241, 0.15); color: var(--brand-primary); border: 1px solid rgba(99, 102, 241, 0.2); }
.sidebar-nav-item .nav-icon { font-size: 18px; width: 20px; text-align: center; }
.sidebar-section { padding: 8px 14px; font-size: 11px; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.1em; margin-top: 16px; margin-bottom: 4px; }

.sidebar-user {
  padding: 16px 20px;
  border-top: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  gap: 12px;
}
.sidebar-avatar {
  width: 38px; height: 38px;
  background: var(--gradient-primary);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 14px; flex-shrink: 0;
}
.sidebar-user-name { font-size: 13px; font-weight: 600; }
.sidebar-user-role { font-size: 11px; color: var(--brand-primary); font-weight: 500; text-transform: capitalize; }

.dashboard-main {
  margin-left: 260px;
  flex: 1 1;
  min-height: 100vh;
  background: var(--bg-primary);
}
.dashboard-header {
  padding: 20px 32px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(10, 15, 30, 0.8);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 50;
}
.dashboard-title { font-size: 20px; font-weight: 700; }
.dashboard-content { padding: 32px; }

/* Stats Row */
.stats-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; margin-bottom: 32px; }
.stat-card {
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: var(--transition);
}
.stat-card:hover { border-color: var(--border-card); transform: translateY(-2px); }
.stat-icon {
  width: 52px; height: 52px;
  border-radius: var(--radius-md);
  display: flex; align-items: center; justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}
.stat-icon.blue { background: rgba(59, 130, 246, 0.15); }
.stat-icon.purple { background: rgba(99, 102, 241, 0.15); }
.stat-icon.green { background: rgba(16, 185, 129, 0.15); }
.stat-icon.yellow { background: rgba(245, 158, 11, 0.15); }
.stat-card .stat-value { font-size: 28px; font-weight: 800; }
.stat-card .stat-label { font-size: 13px; color: var(--text-muted); margin-top: 2px; }

/* ========================================
   Tables
   ======================================== */
.data-table { width: 100%; border-collapse: collapse; }
.data-table th {
  text-align: left;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  border-bottom: 1px solid var(--border-color);
}
.data-table td {
  padding: 14px 16px;
  font-size: 14px;
  border-bottom: 1px solid rgba(255,255,255,0.04);
  color: var(--text-secondary);
}
.data-table tr:hover td { background: var(--bg-glass); }
.data-table td:first-child { color: var(--text-primary); font-weight: 500; }

/* Table card wrapper */
.table-card {
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  overflow: hidden;
}
.table-card-header {
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.table-card-header h3 { font-size: 16px; font-weight: 700; }

/* ========================================
   Request Detail
   ======================================== */
.request-detail { max-width: 900px; }
.request-header { margin-bottom: 24px; }
.request-header h2 { font-size: 22px; font-weight: 700; margin-bottom: 12px; }
.request-meta { display: flex; gap: 12px; flex-wrap: wrap; }
.response-list { display: flex; flex-direction: column; gap: 16px; margin-top: 24px; }
.response-item {
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 20px;
}
.response-item.admin-response { border-color: rgba(99,102,241,0.3); background: rgba(99,102,241,0.05); }
.response-author { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }
.response-avatar {
  width: 36px; height: 36px;
  background: var(--gradient-primary);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 700;
}
.response-avatar.user-avatar { background: linear-gradient(135deg, #06b6d4, #10b981); }
.response-name { font-size: 14px; font-weight: 600; }
.response-time { font-size: 12px; color: var(--text-muted); }
.response-message { color: var(--text-secondary); font-size: 14px; line-height: 1.7; }

/* ========================================
   Modal
   ======================================== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.modal-box {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 32px;
}
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.modal-header h2 { font-size: 20px; font-weight: 700; }
.modal-close { background: var(--bg-glass); border: 1px solid var(--border-color); color: var(--text-secondary); width: 36px; height: 36px; border-radius: 50%; font-size: 18px; display: flex; align-items: center; justify-content: center; transition: var(--transition); }
.modal-close:hover { color: var(--text-primary); border-color: var(--brand-primary); }

/* ========================================
   Auth Pages
   ======================================== */
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  position: relative;
  overflow: hidden;
}
.auth-card {
  background: var(--bg-glass);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  padding: 40px;
  width: 100%;
  max-width: 440px;
}
.auth-logo { text-align: center; margin-bottom: 32px; }
.auth-logo h1 { font-size: 24px; font-weight: 800; margin-bottom: 8px; }
.auth-logo p { color: var(--text-muted); font-size: 14px; }
.auth-divider { display: flex; align-items: center; gap: 12px; margin: 20px 0; }
.auth-divider::before, .auth-divider::after { content: ''; flex: 1 1; height: 1px; background: var(--border-color); }
.auth-divider span { color: var(--text-muted); font-size: 13px; }

/* ========================================
   Loading & Empty States
   ======================================== */
.loading-spinner {
  width: 36px; height: 36px;
  border: 3px solid var(--border-color);
  border-top-color: var(--brand-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.loading-container { display: flex; align-items: center; justify-content: center; padding: 60px; }
.empty-state {
  text-align: center;
  padding: 60px 24px;
}
.empty-state .empty-icon { font-size: 48px; margin-bottom: 16px; }
.empty-state h3 { font-size: 18px; font-weight: 700; margin-bottom: 8px; }
.empty-state p { color: var(--text-muted); font-size: 14px; }

/* ========================================
   Marquee Slider (Certifications)
   ======================================== */
.marquee-container {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 20px 0;
  display: flex;
}
.marquee-container::before,
.marquee-container::after {
  content: '';
  position: absolute;
  top: 0;
  width: 150px;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}
.marquee-container::before {
  left: 0;
  background: linear-gradient(to right, var(--bg-primary) 0%, transparent 100%);
}
.marquee-container::after {
  right: 0;
  background: linear-gradient(to left, var(--bg-primary) 0%, transparent 100%);
}
.marquee-content {
  display: flex;
  gap: 30px;
  animation: scroll 35s linear infinite;
  min-width: 200%;
}
.marquee-container:hover .marquee-content {
  animation-play-state: paused;
}
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.cert-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 28px;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  min-width: max-content;
  transition: var(--transition);
}
.cert-card:hover {
  background: var(--bg-glass-hover);
  border-color: var(--brand-primary);
  transform: translateY(-4px);
  box-shadow: var(--shadow-glow);
}
.cert-icon { font-size: 32px; }
.cert-title { font-size: 16px; font-weight: 700; color: var(--text-primary); }

/* ========================================
   Footer
   ======================================== */
.footer {
  background: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
  padding: 60px 0 30px;
}
.footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 40px; margin-bottom: 48px; }
.footer-brand p { color: var(--text-muted); font-size: 14px; line-height: 1.7; margin-top: 12px; max-width: 280px; }
.footer-col h4 { font-size: 14px; font-weight: 700; margin-bottom: 16px; }
.footer-col ul li { margin-bottom: 10px; }
.footer-col ul li a { color: var(--text-muted); font-size: 14px; transition: var(--transition); }
.footer-col ul li a:hover { color: var(--text-primary); }
.footer-bottom { display: flex; align-items: center; justify-content: space-between; padding-top: 28px; border-top: 1px solid var(--border-color); }
.footer-bottom p { color: var(--text-muted); font-size: 13px; }
.social-links { display: flex; gap: 12px; }
.social-links a {
  width: 36px; height: 36px;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px;
  transition: var(--transition);
  color: var(--text-muted);
}
.social-links a:hover { border-color: var(--brand-primary); color: var(--brand-primary); }

/* ========================================
   Notification Bell
   ======================================== */
.notif-wrapper { position: relative; }
.notif-btn {
  width: 40px; height: 40px;
  background: var(--bg-glass);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; cursor: pointer; transition: var(--transition);
  color: var(--text-secondary);
}
.notif-btn:hover { border-color: var(--brand-primary); color: var(--brand-primary); }
.notif-badge {
  position: absolute;
  top: -4px; right: -4px;
  width: 18px; height: 18px;
  background: var(--brand-red);
  border-radius: 50%;
  font-size: 10px; font-weight: 700;
  display: flex; align-items: center; justify-content: center;
  color: #fff;
}
.notif-dropdown {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  width: 320px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: 200;
  overflow: hidden;
}
.notif-header { padding: 16px 20px; border-bottom: 1px solid var(--border-color); display: flex; align-items: center; justify-content: space-between; }
.notif-header h4 { font-size: 14px; font-weight: 700; }
.notif-item { padding: 14px 20px; border-bottom: 1px solid rgba(255,255,255,0.04); transition: var(--transition); cursor: pointer; }
.notif-item:hover { background: var(--bg-glass); }
.notif-item.unread { background: rgba(99,102,241,0.05); }
.notif-title { font-size: 13px; font-weight: 600; margin-bottom: 4px; }
.notif-msg { font-size: 12px; color: var(--text-muted); }

/* ========================================
   Plan Limit Bar
   ======================================== */
.limit-bar { background: var(--bg-glass); border: 1px solid var(--border-color); border-radius: var(--radius-md); padding: 16px 20px; margin-bottom: 24px; }
.limit-bar-top { display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 13px; }
.progress-track { height: 6px; background: var(--bg-glass); border-radius: 999px; overflow: hidden; }
.progress-fill { height: 100%; background: var(--gradient-primary); border-radius: 999px; transition: width 0.5s ease; }

/* ========================================
   File Upload
   ======================================== */
.file-upload-zone {
  border: 2px dashed var(--border-color);
  border-radius: var(--radius-md);
  padding: 32px;
  text-align: center;
  cursor: pointer;
  transition: var(--transition);
}
.file-upload-zone:hover, .file-upload-zone.dragging {
  border-color: var(--brand-primary);
  background: rgba(99,102,241,0.05);
}

/* ========================================
   Alerts
   ======================================== */
.alert {
  padding: 12px 16px;
  border-radius: var(--radius-md);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.alert-error { background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.3); color: #fca5a5; }
.alert-success { background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.3); color: #6ee7b7; }
.alert-info { background: rgba(99,102,241,0.1); border: 1px solid rgba(99,102,241,0.3); color: #a5b4fc; }

/* ========================================
   Responsive — Comprehensive Mobile First
   ======================================== */

/* ---- Tablet (≤1024px) ---- */
@media (max-width: 1024px) {
  /* Navbar — collapse at tablet width */
  .navbar-links { display: none; }
  .hamburger-btn { display: flex; }
  .navbar-actions .btn:not(.hamburger-btn) { display: none; }

  .sidebar {
    transform: translateX(-100%);
    z-index: 200;
  }
  .sidebar.mobile-open { transform: translateX(0); }
  .dashboard-main { margin-left: 0; }
  .footer-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
  .pricing-grid { grid-template-columns: repeat(2, 1fr); }
  .hero-title { font-size: clamp(2rem, 4vw, 3.5rem); }

  /* Hero — force single column on tablet */
  .hero .container > div { grid-template-columns: 1fr !important; }

  /* Tools — tighter grid */
  .tools-grid { grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 12px; }

  /* Marquee — prevent cert cards overflowing the viewport */
  .marquee-container { overflow: hidden; }
}

/* ---- Mobile (≤768px) ---- */
@media (max-width: 768px) {
  /* Layout */
  .container { padding: 0 16px; }
  .section { padding: 60px 0; }
  .section-subtitle { font-size: 15px; margin-bottom: 40px; }

  /* Navbar — collapse at 768px */
  .navbar-links { display: none; }
  .hamburger-btn { display: flex; }
  .navbar-actions .btn:not(.hamburger-btn) { display: none; }

  /* Hero — prevent blank space from fixed height */
  .hero { padding-top: 90px; min-height: unset !important; padding-bottom: 50px; }
  .hero-title { font-size: clamp(1.8rem, 7vw, 2.8rem); }
  .hero-subtitle { font-size: 15px; }
  .hero-actions { flex-direction: column; gap: 12px; }
  .hero-actions .btn { width: 100%; justify-content: center; }
  .hero-stats { gap: 20px; flex-wrap: wrap; }
  .stat-number { font-size: 22px; }

  /* Terminal — prevent horizontal overflow */
  pre, code { word-break: break-all; overflow-x: hidden; }

  /* Tools */
  .tools-grid { grid-template-columns: repeat(auto-fill, minmax(90px, 1fr)); gap: 12px; margin-top: 32px; }
  .tool-card { padding: 16px 8px; }
  .tool-icon { font-size: 30px; }
  .tool-name { font-size: 11px; }

  /* Pricing */
  .pricing-grid { grid-template-columns: 1fr; gap: 20px; }
  .pricing-card { padding: 24px 20px; }
  .price-amount { font-size: 40px; }

  /* Steps */
  .steps-grid { grid-template-columns: 1fr; gap: 16px; }

  /* Testimonials */
  .testimonials-grid { grid-template-columns: 1fr; }

  /* Footer */
  .footer { padding: 48px 0 24px; }
  .footer-grid { grid-template-columns: 1fr; gap: 28px; margin-bottom: 32px; }
  .footer-brand p { max-width: 100%; }
  .footer-bottom { flex-direction: column; gap: 14px; text-align: center; }
  .footer-bottom .social-links { justify-content: center; }

  /* Dashboard */
  .dashboard-content { padding: 16px; }
  .dashboard-header { padding: 14px 16px; flex-wrap: wrap; gap: 10px; }
  .dashboard-title { font-size: 16px; }
  .stats-row { grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 20px; }
  .stat-card { padding: 16px; }
  .stat-icon { width: 40px; height: 40px; font-size: 18px; }
  .stat-card .stat-value { font-size: 22px; }

  /* Tables — make scrollable on mobile */
  .table-card { overflow-x: auto; }
  .data-table { min-width: 600px; }
  .table-card-header { flex-direction: column; align-items: flex-start; gap: 12px; }

  /* Sidebar */
  .sidebar { width: 100%; }

  /* Auth */
  .auth-card { padding: 28px 20px; max-width: 100%; }
  .auth-page { padding: 100px 16px 40px; }

  /* Modals */
  .modal-overlay { padding: 16px; align-items: flex-end; }
  .modal-box { padding: 24px 20px; max-height: 92vh; border-radius: var(--radius-lg) var(--radius-lg) 0 0; }

  /* Contact page */
  .contact-grid { grid-template-columns: 1fr !important; }

  /* Marquee certs */
  .cert-card { padding: 12px 18px; }
  .cert-icon { font-size: 26px; }
  .cert-title { font-size: 13px; }

  /* Notif dropdown */
  .notif-dropdown { width: 290px; right: -10px; }

  /* Section titles */
  .section-title { font-size: clamp(1.6rem, 5vw, 2.5rem); }

  /* Request detail */
  .request-meta { flex-direction: column; gap: 8px; }
}

/* ---- Small Phones (≤480px) ---- */
@media (max-width: 480px) {
  /* Hero */
  .hero-title { font-size: clamp(1.5rem, 8vw, 2.2rem); }
  .hero-subtitle { font-size: 14px; }

  /* Buttons */
  .btn { padding: 11px 20px; font-size: 14px; }
  .btn-lg { width: 100%; justify-content: center; padding: 14px 24px; }

  /* Auth */
  .auth-card { padding: 24px 16px; }

  /* Stats */
  .stats-row { grid-template-columns: 1fr; }
  .hero-stats  { flex-direction: column; gap: 12px; }

  /* Modals */
  .modal-box { padding: 20px 16px; }

  /* Pricing */
  .pricing-card { padding: 20px 16px; }
  .plan-name { font-size: 18px; }
  .price-amount { font-size: 36px; }

  /* Footer */
  .footer-grid { gap: 24px; }
  .footer-col h4 { margin-bottom: 10px; }

  /* Dashboard tables */
  .dashboard-header { gap: 8px; }
  .data-table th, .data-table td { padding: 10px 12px; font-size: 13px; }

  /* Tools */
  .tools-grid { grid-template-columns: repeat(3, 1fr); gap: 10px; }
  .tool-card { padding: 14px 6px; }
  .tool-name { font-size: 10px; }

  /* Steps */
  .step-card { padding: 24px 16px; }

  /* Testimonials */
  .testimonial-card { padding: 24px 16px; }

  /* Notif dropdown */
  .notif-dropdown { width: 260px; }

  /* Sidebar user area */
  .sidebar-user-name { font-size: 12px; }

  /* Badge */
  .badge { font-size: 11px; padding: 4px 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;6CAE6C;AAC7C;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;;EAE3C,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;;EAEpB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,yCAAyC;EACzC,sCAAsC;;EAEtC,6DAA6D;EAC7D,0DAA0D;EAC1D,0DAA0D;EAC1D,2DAA2D;;EAE3D,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,+CAA+C;;EAE/C,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,mDAAmD;;EAEnD,mEAAmE;EACnE,wCAAwC;AAC1C;;AAEA;;6CAE6C;AAC7C,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;AACxE,OAAO,uBAAuB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE;AACpF;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA,IAAI,cAAc,EAAE,qBAAqB,EAAE;AAC3C,SAAS,eAAe,EAAE,oBAAoB,EAAE,YAAY,EAAE,aAAa,EAAE;AAC7E;EACE,oBAAoB;EACpB,aAAa;EACb,YAAY;AACd;AACA,MAAM,eAAe,EAAE,YAAY,EAAE;AACrC,KAAK,gBAAgB,EAAE;;AAEvB,cAAc;AACd,sBAAsB,UAAU,EAAE;AAClC,4BAA4B,+BAA+B,EAAE;AAC7D,4BAA4B,gCAAgC,EAAE,kBAAkB,EAAE;;AAElF;;6CAE6C;AAC7C,aAAa,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;AACjE,WAAW,gBAAgB,EAAE;AAC7B,cAAc,eAAe,EAAE;AAC/B,eAAe,kBAAkB,EAAE;AACnC;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;6CAE6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA,mBAAmB,iCAAiC,EAAE;AACtD;EACE,qDAAqD;EACrD,WAAW;AACb;AACA,oBAAoB,2BAA2B,EAAE,YAAY,EAAE;AAC/D,UAAU,iBAAiB,EAAE,eAAe,EAAE;AAC9C,UAAU,kBAAkB,EAAE,eAAe,EAAE;;AAE/C;;6CAE6C;AAC7C;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;6CAE6C;AAC7C;EACE,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,yCAAyC;EACzC,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;6CAE6C;AAC7C,cAAc,mBAAmB,EAAE;AACnC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,8CAA8C;AAChD;AACA,6BAA6B,wBAAwB,EAAE;AACvD,uBAAuB,+BAA+B,EAAE,0BAA0B,EAAE;AACpF,wBAAwB,gBAAgB,EAAE,iBAAiB,EAAE;;AAE7D;;6CAE6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,eAAe,oCAAoC,EAAE,cAAc,EAAE,yCAAyC,EAAE;AAChH,sBAAsB,oCAAoC,EAAE,cAAc,EAAE,yCAAyC,EAAE;AACvH,mBAAmB,oCAAoC,EAAE,cAAc,EAAE,yCAAyC,EAAE;AACpH,iBAAiB,qCAAqC,EAAE,cAAc,EAAE,0CAA0C,EAAE;;AAEpH,gBAAgB,cAAc,EAAE;AAChC,mBAAmB,cAAc,EAAE;AACnC,iBAAiB,cAAc,EAAE;AACjC,mBAAmB,cAAc,EAAE;;AAEnC;;6CAE6C;AAC7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9D;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,gDAAgD,0BAA0B,EAAE,2BAA2B,EAAE;AACzG,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACjE,iBAAiB,aAAa,EAAE,2BAA2B,EAAE,qCAAqC,EAAE,0BAA0B,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,eAAe,EAAE;;AAErM;;6CAE6C;AAC7C;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA,cAAc,YAAY,EAAE,aAAa,EAAE,gCAAgC,EAAE,WAAW,EAAE,aAAa,EAAE;AACzG,cAAc,YAAY,EAAE,aAAa,EAAE,kCAAkC,EAAE,cAAc,EAAE,YAAY,EAAE;AAC7G,cAAc,YAAY,EAAE,aAAa,EAAE,+BAA+B,EAAE,QAAQ,EAAE,SAAS,EAAE;AACjG,gBAAgB,kBAAkB,EAAE,UAAU,EAAE,gBAAgB,EAAE;AAClE;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,gBAAgB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAChF,cAAc,aAAa,EAAE,SAAS,EAAE;AACxC,aAAa,gBAAgB,EAAE;AAC/B,eAAe,eAAe,EAAE,gBAAgB,EAAE,mCAAmC,EAAE,6BAA6B,EAAE,oCAAoC,EAAE,qBAAqB,EAAE;AACnL,cAAc,eAAe,EAAE,wBAAwB,EAAE,eAAe,EAAE;;AAE1E;;6CAE6C;AAC7C;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;EAC3B,8BAA8B;AAChC;AACA,aAAa,eAAe,EAAE;AAC9B,aAAa,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;;AAE9E;;6CAE6C;AAC7C,cAAc,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACvH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,mCAAmC;EACnC,oBAAoB;EACpB,+BAA+B;AACjC;AACA,2BAA2B,oBAAoB,EAAE;AACjD,mBAAmB,2BAA2B,EAAE,8BAA8B,EAAE;AAChF;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,mCAAmC;EACnC,kBAAkB;EAClB,eAAe,EAAE,gBAAgB;EACjC,mBAAmB;EACnB,4CAA4C;AAC9C;AACA,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACxE,eAAe,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEhF;;6CAE6C;AAC7C,gBAAgB,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACzH;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,+EAA+E;AACjF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;AACb;AACA,aAAa,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACpE,aAAa,4BAA4B,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACjF,cAAc,mBAAmB,EAAE;AACnC,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnE,kBAAkB,eAAe,EAAE,mBAAmB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAChG,gBAAgB,wBAAwB,EAAE,eAAe,EAAE,eAAe,EAAE;AAC5E,iBAAiB,gBAAgB,EAAE,mBAAmB,EAAE;AACxD;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,eAAe;EACf,4CAA4C;EAC5C,eAAe,EAAE,4BAA4B;AAC/C;AACA,+BAA+B,YAAY,EAAE;AAC7C,iBAAiB,yBAAyB,EAAE,eAAe,EAAE,cAAc,EAAE;;AAE7E;;6CAE6C;AAC7C,qBAAqB,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC9H;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,6BAA6B;AAC/B;AACA,0BAA0B,2BAA2B,EAAE,gCAAgC,EAAE;AACzF,SAAS,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACpF,oBAAoB,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAC9H,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACrE;EACE,WAAW,EAAE,YAAY;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB,EAAE,eAAe;AACnC;AACA,eAAe,gBAAgB,EAAE,eAAe,EAAE;AAClD,eAAe,wBAAwB,EAAE,eAAe,EAAE;;AAE1D;;6CAE6C;AAC7C;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,2CAA2C;EAC3C,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA,eAAe,kBAAkB,EAAE,SAAO,EAAE;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;AACA,0BAA0B,2BAA2B,EAAE,0BAA0B,EAAE;AACnF,2BAA2B,oCAAoC,EAAE,2BAA2B,EAAE,yCAAyC,EAAE;AACzI,8BAA8B,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAChF,mBAAmB,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAE3L;EACE,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB,EAAE,eAAe,EAAE,cAAc;AACnD;AACA,qBAAqB,eAAe,EAAE,gBAAgB,EAAE;AACxD,qBAAqB,eAAe,EAAE,2BAA2B,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEjH;EACE,kBAAkB;EAClB,SAAO;EACP,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;AACtD,qBAAqB,aAAa,EAAE;;AAEpC,cAAc;AACd,aAAa,aAAa,EAAE,2DAA2D,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACzH;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;AACA,mBAAmB,gCAAgC,EAAE,2BAA2B,EAAE;AAClF;EACE,WAAW,EAAE,YAAY;EACzB,+BAA+B;EAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe;EACf,cAAc;AAChB;AACA,kBAAkB,oCAAoC,EAAE;AACxD,oBAAoB,oCAAoC,EAAE;AAC1D,mBAAmB,oCAAoC,EAAE;AACzD,oBAAoB,oCAAoC,EAAE;AAC1D,yBAAyB,eAAe,EAAE,gBAAgB,EAAE;AAC5D,yBAAyB,eAAe,EAAE,wBAAwB,EAAE,eAAe,EAAE;;AAErF;;6CAE6C;AAC7C,cAAc,WAAW,EAAE,yBAAyB,EAAE;AACtD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,+CAA+C;EAC/C,4BAA4B;AAC9B;AACA,0BAA0B,2BAA2B,EAAE;AACvD,6BAA6B,0BAA0B,EAAE,gBAAgB,EAAE;;AAE3E,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA,wBAAwB,eAAe,EAAE,gBAAgB,EAAE;;AAE3D;;6CAE6C;AAC7C,kBAAkB,gBAAgB,EAAE;AACpC,kBAAkB,mBAAmB,EAAE;AACvC,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC7E,gBAAgB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAC3D,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACrF;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;AACf;AACA,gCAAgC,kCAAkC,EAAE,iCAAiC,EAAE;AACvG,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACvF;EACE,WAAW,EAAE,YAAY;EACzB,mCAAmC;EACnC,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,gBAAgB;AACnC;AACA,+BAA+B,qDAAqD,EAAE;AACtF,iBAAiB,eAAe,EAAE,gBAAgB,EAAE;AACpD,iBAAiB,eAAe,EAAE,wBAAwB,EAAE;AAC5D,oBAAoB,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAErF;;6CAE6C;AAC7C;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;AACtD,eAAe,2BAA2B,EAAE,qCAAqC,EAAE,4BAA4B,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,6BAA6B,EAAE;AAC7Q,qBAAqB,0BAA0B,EAAE,kCAAkC,EAAE;;AAErF;;6CAE6C;AAC7C;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA,aAAa,kBAAkB,EAAE,mBAAmB,EAAE;AACtD,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACvE,eAAe,wBAAwB,EAAE,eAAe,EAAE;AAC1D,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;AAC/E,8CAA8C,WAAW,EAAE,SAAO,EAAE,WAAW,EAAE,+BAA+B,EAAE;AAClH,qBAAqB,wBAAwB,EAAE,eAAe,EAAE;;AAEhE;;6CAE6C;AAC7C;EACE,WAAW,EAAE,YAAY;EACzB,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;AACtC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;AACpD,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE;AACjG;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA,2BAA2B,eAAe,EAAE,mBAAmB,EAAE;AACjE,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACzE,iBAAiB,wBAAwB,EAAE,eAAe,EAAE;;AAE5D;;6CAE6C;AAC7C;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,6EAA6E;AAC/E;AACA;EACE,QAAQ;EACR,4EAA4E;AAC9E;AACA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;EAC3B,8BAA8B;AAChC;AACA,aAAa,eAAe,EAAE;AAC9B,cAAc,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAE7E;;6CAE6C;AAC7C;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,oBAAoB;AACtB;AACA,eAAe,aAAa,EAAE,sCAAsC,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACtG,kBAAkB,wBAAwB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACnH,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACzE,oBAAoB,mBAAmB,EAAE;AACzC,sBAAsB,wBAAwB,EAAE,eAAe,EAAE,6BAA6B,EAAE;AAChG,4BAA4B,0BAA0B,EAAE;AACxD,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,iBAAiB,EAAE,yCAAyC,EAAE;AACnJ,mBAAmB,wBAAwB,EAAE,eAAe,EAAE;AAC9D,gBAAgB,aAAa,EAAE,SAAS,EAAE;AAC1C;EACE,WAAW,EAAE,YAAY;EACzB,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe;EACf,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA,wBAAwB,kCAAkC,EAAE,2BAA2B,EAAE;;AAEzF;;6CAE6C;AAC7C,iBAAiB,kBAAkB,EAAE;AACrC;EACE,WAAW,EAAE,YAAY;EACzB,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,eAAe,EAAE,6BAA6B;EAC/D,4BAA4B;AAC9B;AACA,mBAAmB,kCAAkC,EAAE,2BAA2B,EAAE;AACpF;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,WAAW,EAAE,YAAY;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe,EAAE,gBAAgB;EACjC,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;AACA,gBAAgB,kBAAkB,EAAE,4CAA4C,EAAE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AACtJ,mBAAmB,eAAe,EAAE,gBAAgB,EAAE;AACtD,cAAc,kBAAkB,EAAE,+CAA+C,EAAE,6BAA6B,EAAE,eAAe,EAAE;AACnI,oBAAoB,2BAA2B,EAAE;AACjD,qBAAqB,iCAAiC,EAAE;AACxD,eAAe,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACtE,aAAa,eAAe,EAAE,wBAAwB,EAAE;;AAExD;;6CAE6C;AAC7C,aAAa,2BAA2B,EAAE,qCAAqC,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC3J,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACrG,kBAAkB,WAAW,EAAE,2BAA2B,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AACpG,iBAAiB,YAAY,EAAE,mCAAmC,EAAE,oBAAoB,EAAE,2BAA2B,EAAE;;AAEvH;;6CAE6C;AAC7C;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;6CAE6C;AAC7C;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA,eAAe,+BAA+B,EAAE,qCAAqC,EAAE,cAAc,EAAE;AACvG,iBAAiB,gCAAgC,EAAE,sCAAsC,EAAE,cAAc,EAAE;AAC3G,cAAc,gCAAgC,EAAE,sCAAsC,EAAE,cAAc,EAAE;;AAExG;;6CAE6C;;AAE7C,+BAA+B;AAC/B;EACE,sCAAsC;EACtC,gBAAgB,aAAa,EAAE;EAC/B,iBAAiB,aAAa,EAAE;EAChC,2CAA2C,aAAa,EAAE;;EAE1D;IACE,4BAA4B;IAC5B,YAAY;EACd;EACA,uBAAuB,wBAAwB,EAAE;EACjD,kBAAkB,cAAc,EAAE;EAClC,eAAe,8BAA8B,EAAE,SAAS,EAAE;EAC1D,gBAAgB,qCAAqC,EAAE;EACvD,cAAc,mCAAmC,EAAE;;EAEnD,yCAAyC;EACzC,yBAAyB,qCAAqC,EAAE;;EAEhE,yBAAyB;EACzB,cAAc,4DAA4D,EAAE,SAAS,EAAE;;EAEvF,0DAA0D;EAC1D,qBAAqB,gBAAgB,EAAE;AACzC;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,aAAa,eAAe,EAAE;EAC9B,WAAW,eAAe,EAAE;EAC5B,oBAAoB,eAAe,EAAE,mBAAmB,EAAE;;EAE1D,+BAA+B;EAC/B,gBAAgB,aAAa,EAAE;EAC/B,iBAAiB,aAAa,EAAE;EAChC,2CAA2C,aAAa,EAAE;;EAE1D,iDAAiD;EACjD,QAAQ,iBAAiB,EAAE,4BAA4B,EAAE,oBAAoB,EAAE;EAC/E,cAAc,qCAAqC,EAAE;EACrD,iBAAiB,eAAe,EAAE;EAClC,gBAAgB,sBAAsB,EAAE,SAAS,EAAE;EACnD,qBAAqB,WAAW,EAAE,uBAAuB,EAAE;EAC3D,cAAc,SAAS,EAAE,eAAe,EAAE;EAC1C,eAAe,eAAe,EAAE;;EAEhC,2CAA2C;EAC3C,YAAY,qBAAqB,EAAE,kBAAkB,EAAE;;EAEvD,UAAU;EACV,cAAc,2DAA2D,EAAE,SAAS,EAAE,gBAAgB,EAAE;EACxG,aAAa,iBAAiB,EAAE;EAChC,aAAa,eAAe,EAAE;EAC9B,aAAa,eAAe,EAAE;;EAE9B,YAAY;EACZ,gBAAgB,0BAA0B,EAAE,SAAS,EAAE;EACvD,gBAAgB,kBAAkB,EAAE;EACpC,gBAAgB,eAAe,EAAE;;EAEjC,UAAU;EACV,cAAc,0BAA0B,EAAE,SAAS,EAAE;;EAErD,iBAAiB;EACjB,qBAAqB,0BAA0B,EAAE;;EAEjD,WAAW;EACX,UAAU,oBAAoB,EAAE;EAChC,eAAe,0BAA0B,EAAE,SAAS,EAAE,mBAAmB,EAAE;EAC3E,kBAAkB,eAAe,EAAE;EACnC,iBAAiB,sBAAsB,EAAE,SAAS,EAAE,kBAAkB,EAAE;EACxE,+BAA+B,uBAAuB,EAAE;;EAExD,cAAc;EACd,qBAAqB,aAAa,EAAE;EACpC,oBAAoB,kBAAkB,EAAE,eAAe,EAAE,SAAS,EAAE;EACpE,mBAAmB,eAAe,EAAE;EACpC,aAAa,qCAAqC,EAAE,SAAS,EAAE,mBAAmB,EAAE;EACpF,aAAa,aAAa,EAAE;EAC5B,aAAa,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE;EACzD,yBAAyB,eAAe,EAAE;;EAE1C,uCAAuC;EACvC,cAAc,gBAAgB,EAAE;EAChC,cAAc,gBAAgB,EAAE;EAChC,qBAAqB,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE;;EAEjF,YAAY;EACZ,WAAW,WAAW,EAAE;;EAExB,SAAS;EACT,aAAa,kBAAkB,EAAE,eAAe,EAAE;EAClD,aAAa,wBAAwB,EAAE;;EAEvC,WAAW;EACX,iBAAiB,aAAa,EAAE,qBAAqB,EAAE;EACvD,aAAa,kBAAkB,EAAE,gBAAgB,EAAE,oDAAoD,EAAE;;EAEzG,iBAAiB;EACjB,gBAAgB,qCAAqC,EAAE;;EAEvD,kBAAkB;EAClB,aAAa,kBAAkB,EAAE;EACjC,aAAa,eAAe,EAAE;EAC9B,cAAc,eAAe,EAAE;;EAE/B,mBAAmB;EACnB,kBAAkB,YAAY,EAAE,YAAY,EAAE;;EAE9C,mBAAmB;EACnB,iBAAiB,qCAAqC,EAAE;;EAExD,mBAAmB;EACnB,gBAAgB,sBAAsB,EAAE,QAAQ,EAAE;AACpD;;AAEA,oCAAoC;AACpC;EACE,SAAS;EACT,cAAc,qCAAqC,EAAE;EACrD,iBAAiB,eAAe,EAAE;;EAElC,YAAY;EACZ,OAAO,kBAAkB,EAAE,eAAe,EAAE;EAC5C,UAAU,WAAW,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;;EAEpE,SAAS;EACT,aAAa,kBAAkB,EAAE;;EAEjC,UAAU;EACV,aAAa,0BAA0B,EAAE;EACzC,eAAe,sBAAsB,EAAE,SAAS,EAAE;;EAElD,WAAW;EACX,aAAa,kBAAkB,EAAE;;EAEjC,YAAY;EACZ,gBAAgB,kBAAkB,EAAE;EACpC,aAAa,eAAe,EAAE;EAC9B,gBAAgB,eAAe,EAAE;;EAEjC,WAAW;EACX,eAAe,SAAS,EAAE;EAC1B,iBAAiB,mBAAmB,EAAE;;EAEtC,qBAAqB;EACrB,oBAAoB,QAAQ,EAAE;EAC9B,iCAAiC,kBAAkB,EAAE,eAAe,EAAE;;EAEtE,UAAU;EACV,cAAc,qCAAqC,EAAE,SAAS,EAAE;EAChE,aAAa,iBAAiB,EAAE;EAChC,aAAa,eAAe,EAAE;;EAE9B,UAAU;EACV,aAAa,kBAAkB,EAAE;;EAEjC,iBAAiB;EACjB,oBAAoB,kBAAkB,EAAE;;EAExC,mBAAmB;EACnB,kBAAkB,YAAY,EAAE;;EAEhC,sBAAsB;EACtB,qBAAqB,eAAe,EAAE;;EAEtC,UAAU;EACV,SAAS,eAAe,EAAE,iBAAiB,EAAE;AAC/C","sourcesContent":["/* ========================================\n   CSS Custom Properties / Design Tokens\n   ======================================== */\n:root {\n  --bg-primary: #0a0f1e;\n  --bg-secondary: #0f172a;\n  --bg-card: rgba(15, 23, 42, 0.8);\n  --bg-glass: rgba(255, 255, 255, 0.05);\n  --bg-glass-hover: rgba(255, 255, 255, 0.08);\n\n  --brand-primary: #6366f1;\n  --brand-secondary: #8b5cf6;\n  --brand-accent: #06b6d4;\n  --brand-pink: #ec4899;\n  --brand-green: #10b981;\n  --brand-yellow: #f59e0b;\n  --brand-red: #ef4444;\n\n  --text-primary: #f1f5f9;\n  --text-secondary: #94a3b8;\n  --text-muted: #64748b;\n\n  --border-color: rgba(255, 255, 255, 0.08);\n  --border-card: rgba(99, 102, 241, 0.2);\n\n  --gradient-primary: linear-gradient(135deg, #6366f1, #8b5cf6);\n  --gradient-cool: linear-gradient(135deg, #06b6d4, #6366f1);\n  --gradient-warm: linear-gradient(135deg, #f59e0b, #ef4444);\n  --gradient-green: linear-gradient(135deg, #10b981, #06b6d4);\n\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);\n  --shadow-md: 0 4px 20px rgba(0, 0, 0, 0.4);\n  --shadow-lg: 0 8px 40px rgba(0, 0, 0, 0.5);\n  --shadow-glow: 0 0 30px rgba(99, 102, 241, 0.3);\n\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 24px;\n\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n  --font-main: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  --font-mono: 'JetBrains Mono', monospace;\n}\n\n/* ========================================\n   Reset & Base\n   ======================================== */\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\nhtml { scroll-behavior: smooth; -webkit-text-size-adjust: 100%; overflow-x: hidden; }\nbody {\n  font-family: var(--font-main);\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  line-height: 1.6;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\na { color: inherit; text-decoration: none; }\nbutton { cursor: pointer; font-family: inherit; border: none; outline: none; }\ninput, textarea, select {\n  font-family: inherit;\n  outline: none;\n  border: none;\n}\nimg { max-width: 100%; height: auto; }\nul { list-style: none; }\n\n/* Scrollbar */\n::-webkit-scrollbar { width: 6px; }\n::-webkit-scrollbar-track { background: var(--bg-secondary); }\n::-webkit-scrollbar-thumb { background: var(--brand-primary); border-radius: 3px; }\n\n/* ========================================\n   Utility Classes\n   ======================================== */\n.container { max-width: 1200px; margin: 0 auto; padding: 0 24px; }\n.section { padding: 100px 0; }\n.section-sm { padding: 60px 0; }\n.text-center { text-align: center; }\n.text-gradient {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n.text-gradient-cool {\n  background: var(--gradient-cool);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* ========================================\n   Buttons\n   ======================================== */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 28px;\n  border-radius: var(--radius-md);\n  font-size: 15px;\n  font-weight: 600;\n  transition: var(--transition);\n  white-space: nowrap;\n}\n.btn-primary {\n  background: var(--gradient-primary);\n  color: #fff;\n  box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);\n}\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 35px rgba(99, 102, 241, 0.6);\n}\n.btn-secondary {\n  background: transparent;\n  border: 1px solid var(--brand-primary);\n  color: var(--brand-primary);\n}\n.btn-secondary:hover {\n  background: rgba(99, 102, 241, 0.1);\n  transform: translateY(-2px);\n}\n.btn-ghost {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  backdrop-filter: blur(10px);\n}\n.btn-ghost:hover { background: var(--bg-glass-hover); }\n.btn-danger {\n  background: linear-gradient(135deg, #ef4444, #dc2626);\n  color: #fff;\n}\n.btn-danger:hover { transform: translateY(-2px); opacity: 0.9; }\n.btn-sm { padding: 8px 16px; font-size: 13px; }\n.btn-lg { padding: 16px 40px; font-size: 17px; }\n\n/* ========================================\n   Glass Cards\n   ======================================== */\n.glass-card {\n  background: var(--bg-glass);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 28px;\n  transition: var(--transition);\n}\n.glass-card:hover {\n  background: var(--bg-glass-hover);\n  border-color: var(--border-card);\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-glow);\n}\n\n/* ========================================\n   Typography\n   ======================================== */\n.section-title {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.02em;\n  margin-bottom: 16px;\n}\n.section-subtitle {\n  font-size: 18px;\n  color: var(--text-secondary);\n  max-width: 600px;\n  margin: 0 auto 60px;\n  line-height: 1.7;\n}\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(99, 102, 241, 0.15);\n  border: 1px solid rgba(99, 102, 241, 0.3);\n  color: var(--brand-primary);\n  padding: 6px 14px;\n  border-radius: 100px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  margin-bottom: 20px;\n}\n\n/* ========================================\n   Forms\n   ======================================== */\n.form-group { margin-bottom: 20px; }\n.form-label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n.form-control {\n  width: 100%;\n  padding: 12px 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 15px;\n  transition: var(--transition);\n}\n.form-control:focus {\n  border-color: var(--brand-primary);\n  background: rgba(99, 102, 241, 0.08);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n.form-control::placeholder { color: var(--text-muted); }\n.form-control option { background: var(--bg-secondary); color: var(--text-primary); }\ntextarea.form-control { resize: vertical; min-height: 120px; }\n\n/* ========================================\n   Status Badges\n   ======================================== */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 100px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.status-open { background: rgba(59, 130, 246, 0.15); color: #60a5fa; border: 1px solid rgba(59, 130, 246, 0.3); }\n.status-in_progress { background: rgba(245, 158, 11, 0.15); color: #fbbf24; border: 1px solid rgba(245, 158, 11, 0.3); }\n.status-resolved { background: rgba(16, 185, 129, 0.15); color: #34d399; border: 1px solid rgba(16, 185, 129, 0.3); }\n.status-closed { background: rgba(107, 114, 128, 0.15); color: #9ca3af; border: 1px solid rgba(107, 114, 128, 0.3); }\n\n.priority-low { color: #34d399; }\n.priority-medium { color: #fbbf24; }\n.priority-high { color: #f87171; }\n.priority-urgent { color: #ef4444; }\n\n/* ========================================\n   Navbar\n   ======================================== */\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  padding: 16px 0;\n  transition: var(--transition);\n}\n.navbar.scrolled {\n  background: rgba(10, 15, 30, 0.95);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid var(--border-color);\n  padding: 12px 0;\n}\n.navbar-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 22px;\n  font-weight: 800;\n}\n.logo-icon {\n  width: 38px;\n  height: 38px;\n  background: var(--gradient-primary);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n.navbar-links { display: flex; align-items: center; gap: 8px; }\n.navbar-links a {\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n}\n.navbar-links a:hover, .navbar-links a.active { color: var(--text-primary); background: var(--bg-glass); }\n.navbar-actions { display: flex; align-items: center; gap: 12px; }\n.hamburger-btn { display: none; background: var(--bg-glass); border: 1px solid var(--border-color); color: var(--text-primary); padding: 8px 12px; border-radius: var(--radius-sm); font-size: 18px; }\n\n/* ========================================\n   Hero\n   ======================================== */\n.hero {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  padding-top: 80px;\n  position: relative;\n  overflow: hidden;\n}\n.hero-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n.hero-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(100px);\n  opacity: 0.15;\n}\n.hero-orb-1 { width: 600px; height: 600px; background: var(--brand-primary); top: -200px; right: -100px; }\n.hero-orb-2 { width: 400px; height: 400px; background: var(--brand-secondary); bottom: -100px; left: -100px; }\n.hero-orb-3 { width: 300px; height: 300px; background: var(--brand-accent); top: 50%; left: 40%; }\n.hero-content { position: relative; z-index: 1; max-width: 800px; }\n.hero-title {\n  font-size: clamp(2.5rem, 6vw, 4.5rem);\n  font-weight: 900;\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n  margin-bottom: 24px;\n}\n.hero-subtitle {\n  font-size: clamp(16px, 2vw, 20px);\n  color: var(--text-secondary);\n  line-height: 1.7;\n  margin-bottom: 40px;\n  max-width: 600px;\n}\n.hero-actions { display: flex; gap: 16px; flex-wrap: wrap; margin-bottom: 60px; }\n.hero-stats { display: flex; gap: 40px; }\n.stat-item { text-align: left; }\n.stat-number { font-size: 28px; font-weight: 800; background: var(--gradient-primary); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }\n.stat-label { font-size: 13px; color: var(--text-muted); margin-top: 2px; }\n\n/* ========================================\n   Tools Grid\n   ======================================== */\n.tools-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 16px;\n  margin-top: 60px;\n  width: 100%;\n  overflow: hidden;\n}\n.tool-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 16px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  transition: var(--transition);\n  text-align: center;\n}\n.tool-card:hover {\n  background: var(--bg-glass-hover);\n  border-color: var(--border-card);\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-glow);\n}\n.tool-icon { font-size: 40px; }\n.tool-name { font-size: 13px; font-weight: 600; color: var(--text-secondary); }\n\n/* ========================================\n   How It Works\n   ======================================== */\n.steps-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 24px; margin-top: 60px; }\n.step-card {\n  text-align: center;\n  padding: 36px 24px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  position: relative;\n  overflow: hidden;\n  transition: var(--transition);\n}\n.step-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: var(--gradient-primary);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n.step-card:hover::before { transform: scaleX(1); }\n.step-card:hover { transform: translateY(-6px); box-shadow: var(--shadow-glow); }\n.step-number {\n  width: 56px; height: 56px;\n  display: flex; align-items: center; justify-content: center;\n  background: var(--gradient-primary);\n  border-radius: 50%;\n  font-size: 22px; font-weight: 800;\n  margin: 0 auto 20px;\n  box-shadow: 0 0 20px rgba(99, 102, 241, 0.4);\n}\n.step-card h3 { font-size: 18px; font-weight: 700; margin-bottom: 12px; }\n.step-card p { color: var(--text-secondary); font-size: 14px; line-height: 1.7; }\n\n/* ========================================\n   Pricing\n   ======================================== */\n.pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; margin-top: 60px; }\n.pricing-card {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-xl);\n  padding: 24px;\n  position: relative;\n  transition: var(--transition);\n  overflow: visible;\n}\n.pricing-card:hover, .pricing-card.featured {\n  border-color: var(--brand-primary);\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-glow);\n}\n.pricing-card.featured {\n  background: linear-gradient(145deg, rgba(99,102,241,0.1), rgba(139,92,246,0.1));\n}\n.featured-badge {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--gradient-primary);\n  padding: 6px 16px;\n  border-radius: 100px;\n  font-size: 12px; \n  font-weight: 700;\n  white-space: nowrap;\n  box-shadow: var(--shadow-md);\n  z-index: 10;\n}\n.plan-name { font-size: 22px; font-weight: 700; margin-bottom: 8px; }\n.plan-desc { color: var(--text-secondary); font-size: 14px; margin-bottom: 24px; }\n.plan-price { margin-bottom: 28px; }\n.price-amount { font-size: 48px; font-weight: 900; line-height: 1; }\n.price-currency { font-size: 24px; vertical-align: top; margin-top: 8px; display: inline-block; }\n.price-period { color: var(--text-muted); font-size: 14px; margin-top: 4px; }\n.plan-features { list-style: none; margin-bottom: 32px; }\n.plan-features li {\n  display: flex; align-items: center; gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border-color);\n  font-size: 14px; color: var(--text-secondary);\n}\n.plan-features li:last-child { border: none; }\n.feature-check { color: var(--brand-green); font-size: 16px; flex-shrink: 0; }\n\n/* ========================================\n   Testimonials\n   ======================================== */\n.testimonials-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; margin-top: 60px; }\n.testimonial-card {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 32px;\n  transition: var(--transition);\n}\n.testimonial-card:hover { transform: translateY(-4px); border-color: var(--border-card); }\n.stars { color: #fbbf24; font-size: 16px; margin-bottom: 16px; letter-spacing: 2px; }\n.testimonial-text { color: var(--text-secondary); font-size: 15px; line-height: 1.8; margin-bottom: 24px; font-style: italic; }\n.testimonial-author { display: flex; align-items: center; gap: 14px; }\n.author-avatar {\n  width: 44px; height: 44px;\n  background: var(--gradient-primary);\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  font-weight: 700; font-size: 16px;\n}\n.author-name { font-weight: 600; font-size: 15px; }\n.author-role { color: var(--text-muted); font-size: 13px; }\n\n/* ========================================\n   Dashboard Layout\n   ======================================== */\n.dashboard-layout {\n  display: flex;\n  min-height: 100vh;\n  padding-top: 0;\n}\n.sidebar {\n  width: 260px;\n  min-height: 100vh;\n  background: var(--bg-secondary);\n  border-right: 1px solid var(--border-color);\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 100;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.3s ease;\n}\n.sidebar-logo {\n  padding: 24px 20px;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 18px;\n  font-weight: 800;\n}\n.sidebar-nav { padding: 20px 12px; flex: 1; }\n.sidebar-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: var(--radius-md);\n  color: var(--text-muted);\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n  cursor: pointer;\n  margin-bottom: 4px;\n  width: 100%;\n  background: transparent;\n  text-align: left;\n}\n.sidebar-nav-item:hover { background: var(--bg-glass); color: var(--text-primary); }\n.sidebar-nav-item.active { background: rgba(99, 102, 241, 0.15); color: var(--brand-primary); border: 1px solid rgba(99, 102, 241, 0.2); }\n.sidebar-nav-item .nav-icon { font-size: 18px; width: 20px; text-align: center; }\n.sidebar-section { padding: 8px 14px; font-size: 11px; font-weight: 700; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.1em; margin-top: 16px; margin-bottom: 4px; }\n\n.sidebar-user {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.sidebar-avatar {\n  width: 38px; height: 38px;\n  background: var(--gradient-primary);\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  font-weight: 700; font-size: 14px; flex-shrink: 0;\n}\n.sidebar-user-name { font-size: 13px; font-weight: 600; }\n.sidebar-user-role { font-size: 11px; color: var(--brand-primary); font-weight: 500; text-transform: capitalize; }\n\n.dashboard-main {\n  margin-left: 260px;\n  flex: 1;\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n.dashboard-header {\n  padding: 20px 32px;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: rgba(10, 15, 30, 0.8);\n  backdrop-filter: blur(10px);\n  position: sticky;\n  top: 0;\n  z-index: 50;\n}\n.dashboard-title { font-size: 20px; font-weight: 700; }\n.dashboard-content { padding: 32px; }\n\n/* Stats Row */\n.stats-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 20px; margin-bottom: 32px; }\n.stat-card {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  transition: var(--transition);\n}\n.stat-card:hover { border-color: var(--border-card); transform: translateY(-2px); }\n.stat-icon {\n  width: 52px; height: 52px;\n  border-radius: var(--radius-md);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 22px;\n  flex-shrink: 0;\n}\n.stat-icon.blue { background: rgba(59, 130, 246, 0.15); }\n.stat-icon.purple { background: rgba(99, 102, 241, 0.15); }\n.stat-icon.green { background: rgba(16, 185, 129, 0.15); }\n.stat-icon.yellow { background: rgba(245, 158, 11, 0.15); }\n.stat-card .stat-value { font-size: 28px; font-weight: 800; }\n.stat-card .stat-label { font-size: 13px; color: var(--text-muted); margin-top: 2px; }\n\n/* ========================================\n   Tables\n   ======================================== */\n.data-table { width: 100%; border-collapse: collapse; }\n.data-table th {\n  text-align: left;\n  padding: 12px 16px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  border-bottom: 1px solid var(--border-color);\n}\n.data-table td {\n  padding: 14px 16px;\n  font-size: 14px;\n  border-bottom: 1px solid rgba(255,255,255,0.04);\n  color: var(--text-secondary);\n}\n.data-table tr:hover td { background: var(--bg-glass); }\n.data-table td:first-child { color: var(--text-primary); font-weight: 500; }\n\n/* Table card wrapper */\n.table-card {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n.table-card-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.table-card-header h3 { font-size: 16px; font-weight: 700; }\n\n/* ========================================\n   Request Detail\n   ======================================== */\n.request-detail { max-width: 900px; }\n.request-header { margin-bottom: 24px; }\n.request-header h2 { font-size: 22px; font-weight: 700; margin-bottom: 12px; }\n.request-meta { display: flex; gap: 12px; flex-wrap: wrap; }\n.response-list { display: flex; flex-direction: column; gap: 16px; margin-top: 24px; }\n.response-item {\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n}\n.response-item.admin-response { border-color: rgba(99,102,241,0.3); background: rgba(99,102,241,0.05); }\n.response-author { display: flex; align-items: center; gap: 12px; margin-bottom: 12px; }\n.response-avatar {\n  width: 36px; height: 36px;\n  background: var(--gradient-primary);\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 13px; font-weight: 700;\n}\n.response-avatar.user-avatar { background: linear-gradient(135deg, #06b6d4, #10b981); }\n.response-name { font-size: 14px; font-weight: 600; }\n.response-time { font-size: 12px; color: var(--text-muted); }\n.response-message { color: var(--text-secondary); font-size: 14px; line-height: 1.7; }\n\n/* ========================================\n   Modal\n   ======================================== */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(8px);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n.modal-box {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 560px;\n  max-height: 90vh;\n  overflow-y: auto;\n  padding: 32px;\n}\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n.modal-header h2 { font-size: 20px; font-weight: 700; }\n.modal-close { background: var(--bg-glass); border: 1px solid var(--border-color); color: var(--text-secondary); width: 36px; height: 36px; border-radius: 50%; font-size: 18px; display: flex; align-items: center; justify-content: center; transition: var(--transition); }\n.modal-close:hover { color: var(--text-primary); border-color: var(--brand-primary); }\n\n/* ========================================\n   Auth Pages\n   ======================================== */\n.auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 24px;\n  position: relative;\n  overflow: hidden;\n}\n.auth-card {\n  background: var(--bg-glass);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-xl);\n  padding: 40px;\n  width: 100%;\n  max-width: 440px;\n}\n.auth-logo { text-align: center; margin-bottom: 32px; }\n.auth-logo h1 { font-size: 24px; font-weight: 800; margin-bottom: 8px; }\n.auth-logo p { color: var(--text-muted); font-size: 14px; }\n.auth-divider { display: flex; align-items: center; gap: 12px; margin: 20px 0; }\n.auth-divider::before, .auth-divider::after { content: ''; flex: 1; height: 1px; background: var(--border-color); }\n.auth-divider span { color: var(--text-muted); font-size: 13px; }\n\n/* ========================================\n   Loading & Empty States\n   ======================================== */\n.loading-spinner {\n  width: 36px; height: 36px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--brand-primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n.loading-container { display: flex; align-items: center; justify-content: center; padding: 60px; }\n.empty-state {\n  text-align: center;\n  padding: 60px 24px;\n}\n.empty-state .empty-icon { font-size: 48px; margin-bottom: 16px; }\n.empty-state h3 { font-size: 18px; font-weight: 700; margin-bottom: 8px; }\n.empty-state p { color: var(--text-muted); font-size: 14px; }\n\n/* ========================================\n   Marquee Slider (Certifications)\n   ======================================== */\n.marquee-container {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  padding: 20px 0;\n  display: flex;\n}\n.marquee-container::before,\n.marquee-container::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  width: 150px;\n  height: 100%;\n  z-index: 2;\n  pointer-events: none;\n}\n.marquee-container::before {\n  left: 0;\n  background: linear-gradient(to right, var(--bg-primary) 0%, transparent 100%);\n}\n.marquee-container::after {\n  right: 0;\n  background: linear-gradient(to left, var(--bg-primary) 0%, transparent 100%);\n}\n.marquee-content {\n  display: flex;\n  gap: 30px;\n  animation: scroll 35s linear infinite;\n  min-width: 200%;\n}\n.marquee-container:hover .marquee-content {\n  animation-play-state: paused;\n}\n@keyframes scroll {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n\n.cert-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px 28px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  min-width: max-content;\n  transition: var(--transition);\n}\n.cert-card:hover {\n  background: var(--bg-glass-hover);\n  border-color: var(--brand-primary);\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-glow);\n}\n.cert-icon { font-size: 32px; }\n.cert-title { font-size: 16px; font-weight: 700; color: var(--text-primary); }\n\n/* ========================================\n   Footer\n   ======================================== */\n.footer {\n  background: var(--bg-secondary);\n  border-top: 1px solid var(--border-color);\n  padding: 60px 0 30px;\n}\n.footer-grid { display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 40px; margin-bottom: 48px; }\n.footer-brand p { color: var(--text-muted); font-size: 14px; line-height: 1.7; margin-top: 12px; max-width: 280px; }\n.footer-col h4 { font-size: 14px; font-weight: 700; margin-bottom: 16px; }\n.footer-col ul li { margin-bottom: 10px; }\n.footer-col ul li a { color: var(--text-muted); font-size: 14px; transition: var(--transition); }\n.footer-col ul li a:hover { color: var(--text-primary); }\n.footer-bottom { display: flex; align-items: center; justify-content: space-between; padding-top: 28px; border-top: 1px solid var(--border-color); }\n.footer-bottom p { color: var(--text-muted); font-size: 13px; }\n.social-links { display: flex; gap: 12px; }\n.social-links a {\n  width: 36px; height: 36px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 14px;\n  transition: var(--transition);\n  color: var(--text-muted);\n}\n.social-links a:hover { border-color: var(--brand-primary); color: var(--brand-primary); }\n\n/* ========================================\n   Notification Bell\n   ======================================== */\n.notif-wrapper { position: relative; }\n.notif-btn {\n  width: 40px; height: 40px;\n  background: var(--bg-glass);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 18px; cursor: pointer; transition: var(--transition);\n  color: var(--text-secondary);\n}\n.notif-btn:hover { border-color: var(--brand-primary); color: var(--brand-primary); }\n.notif-badge {\n  position: absolute;\n  top: -4px; right: -4px;\n  width: 18px; height: 18px;\n  background: var(--brand-red);\n  border-radius: 50%;\n  font-size: 10px; font-weight: 700;\n  display: flex; align-items: center; justify-content: center;\n  color: #fff;\n}\n.notif-dropdown {\n  position: absolute;\n  top: calc(100% + 12px);\n  right: 0;\n  width: 320px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  z-index: 200;\n  overflow: hidden;\n}\n.notif-header { padding: 16px 20px; border-bottom: 1px solid var(--border-color); display: flex; align-items: center; justify-content: space-between; }\n.notif-header h4 { font-size: 14px; font-weight: 700; }\n.notif-item { padding: 14px 20px; border-bottom: 1px solid rgba(255,255,255,0.04); transition: var(--transition); cursor: pointer; }\n.notif-item:hover { background: var(--bg-glass); }\n.notif-item.unread { background: rgba(99,102,241,0.05); }\n.notif-title { font-size: 13px; font-weight: 600; margin-bottom: 4px; }\n.notif-msg { font-size: 12px; color: var(--text-muted); }\n\n/* ========================================\n   Plan Limit Bar\n   ======================================== */\n.limit-bar { background: var(--bg-glass); border: 1px solid var(--border-color); border-radius: var(--radius-md); padding: 16px 20px; margin-bottom: 24px; }\n.limit-bar-top { display: flex; justify-content: space-between; margin-bottom: 8px; font-size: 13px; }\n.progress-track { height: 6px; background: var(--bg-glass); border-radius: 999px; overflow: hidden; }\n.progress-fill { height: 100%; background: var(--gradient-primary); border-radius: 999px; transition: width 0.5s ease; }\n\n/* ========================================\n   File Upload\n   ======================================== */\n.file-upload-zone {\n  border: 2px dashed var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 32px;\n  text-align: center;\n  cursor: pointer;\n  transition: var(--transition);\n}\n.file-upload-zone:hover, .file-upload-zone.dragging {\n  border-color: var(--brand-primary);\n  background: rgba(99,102,241,0.05);\n}\n\n/* ========================================\n   Alerts\n   ======================================== */\n.alert {\n  padding: 12px 16px;\n  border-radius: var(--radius-md);\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.alert-error { background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.3); color: #fca5a5; }\n.alert-success { background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.3); color: #6ee7b7; }\n.alert-info { background: rgba(99,102,241,0.1); border: 1px solid rgba(99,102,241,0.3); color: #a5b4fc; }\n\n/* ========================================\n   Responsive — Comprehensive Mobile First\n   ======================================== */\n\n/* ---- Tablet (≤1024px) ---- */\n@media (max-width: 1024px) {\n  /* Navbar — collapse at tablet width */\n  .navbar-links { display: none; }\n  .hamburger-btn { display: flex; }\n  .navbar-actions .btn:not(.hamburger-btn) { display: none; }\n\n  .sidebar {\n    transform: translateX(-100%);\n    z-index: 200;\n  }\n  .sidebar.mobile-open { transform: translateX(0); }\n  .dashboard-main { margin-left: 0; }\n  .footer-grid { grid-template-columns: 1fr 1fr; gap: 32px; }\n  .pricing-grid { grid-template-columns: repeat(2, 1fr); }\n  .hero-title { font-size: clamp(2rem, 4vw, 3.5rem); }\n\n  /* Hero — force single column on tablet */\n  .hero .container > div { grid-template-columns: 1fr !important; }\n\n  /* Tools — tighter grid */\n  .tools-grid { grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); gap: 12px; }\n\n  /* Marquee — prevent cert cards overflowing the viewport */\n  .marquee-container { overflow: hidden; }\n}\n\n/* ---- Mobile (≤768px) ---- */\n@media (max-width: 768px) {\n  /* Layout */\n  .container { padding: 0 16px; }\n  .section { padding: 60px 0; }\n  .section-subtitle { font-size: 15px; margin-bottom: 40px; }\n\n  /* Navbar — collapse at 768px */\n  .navbar-links { display: none; }\n  .hamburger-btn { display: flex; }\n  .navbar-actions .btn:not(.hamburger-btn) { display: none; }\n\n  /* Hero — prevent blank space from fixed height */\n  .hero { padding-top: 90px; min-height: unset !important; padding-bottom: 50px; }\n  .hero-title { font-size: clamp(1.8rem, 7vw, 2.8rem); }\n  .hero-subtitle { font-size: 15px; }\n  .hero-actions { flex-direction: column; gap: 12px; }\n  .hero-actions .btn { width: 100%; justify-content: center; }\n  .hero-stats { gap: 20px; flex-wrap: wrap; }\n  .stat-number { font-size: 22px; }\n\n  /* Terminal — prevent horizontal overflow */\n  pre, code { word-break: break-all; overflow-x: hidden; }\n\n  /* Tools */\n  .tools-grid { grid-template-columns: repeat(auto-fill, minmax(90px, 1fr)); gap: 12px; margin-top: 32px; }\n  .tool-card { padding: 16px 8px; }\n  .tool-icon { font-size: 30px; }\n  .tool-name { font-size: 11px; }\n\n  /* Pricing */\n  .pricing-grid { grid-template-columns: 1fr; gap: 20px; }\n  .pricing-card { padding: 24px 20px; }\n  .price-amount { font-size: 40px; }\n\n  /* Steps */\n  .steps-grid { grid-template-columns: 1fr; gap: 16px; }\n\n  /* Testimonials */\n  .testimonials-grid { grid-template-columns: 1fr; }\n\n  /* Footer */\n  .footer { padding: 48px 0 24px; }\n  .footer-grid { grid-template-columns: 1fr; gap: 28px; margin-bottom: 32px; }\n  .footer-brand p { max-width: 100%; }\n  .footer-bottom { flex-direction: column; gap: 14px; text-align: center; }\n  .footer-bottom .social-links { justify-content: center; }\n\n  /* Dashboard */\n  .dashboard-content { padding: 16px; }\n  .dashboard-header { padding: 14px 16px; flex-wrap: wrap; gap: 10px; }\n  .dashboard-title { font-size: 16px; }\n  .stats-row { grid-template-columns: repeat(2, 1fr); gap: 12px; margin-bottom: 20px; }\n  .stat-card { padding: 16px; }\n  .stat-icon { width: 40px; height: 40px; font-size: 18px; }\n  .stat-card .stat-value { font-size: 22px; }\n\n  /* Tables — make scrollable on mobile */\n  .table-card { overflow-x: auto; }\n  .data-table { min-width: 600px; }\n  .table-card-header { flex-direction: column; align-items: flex-start; gap: 12px; }\n\n  /* Sidebar */\n  .sidebar { width: 100%; }\n\n  /* Auth */\n  .auth-card { padding: 28px 20px; max-width: 100%; }\n  .auth-page { padding: 100px 16px 40px; }\n\n  /* Modals */\n  .modal-overlay { padding: 16px; align-items: flex-end; }\n  .modal-box { padding: 24px 20px; max-height: 92vh; border-radius: var(--radius-lg) var(--radius-lg) 0 0; }\n\n  /* Contact page */\n  .contact-grid { grid-template-columns: 1fr !important; }\n\n  /* Marquee certs */\n  .cert-card { padding: 12px 18px; }\n  .cert-icon { font-size: 26px; }\n  .cert-title { font-size: 13px; }\n\n  /* Notif dropdown */\n  .notif-dropdown { width: 290px; right: -10px; }\n\n  /* Section titles */\n  .section-title { font-size: clamp(1.6rem, 5vw, 2.5rem); }\n\n  /* Request detail */\n  .request-meta { flex-direction: column; gap: 8px; }\n}\n\n/* ---- Small Phones (≤480px) ---- */\n@media (max-width: 480px) {\n  /* Hero */\n  .hero-title { font-size: clamp(1.5rem, 8vw, 2.2rem); }\n  .hero-subtitle { font-size: 14px; }\n\n  /* Buttons */\n  .btn { padding: 11px 20px; font-size: 14px; }\n  .btn-lg { width: 100%; justify-content: center; padding: 14px 24px; }\n\n  /* Auth */\n  .auth-card { padding: 24px 16px; }\n\n  /* Stats */\n  .stats-row { grid-template-columns: 1fr; }\n  .hero-stats  { flex-direction: column; gap: 12px; }\n\n  /* Modals */\n  .modal-box { padding: 20px 16px; }\n\n  /* Pricing */\n  .pricing-card { padding: 20px 16px; }\n  .plan-name { font-size: 18px; }\n  .price-amount { font-size: 36px; }\n\n  /* Footer */\n  .footer-grid { gap: 24px; }\n  .footer-col h4 { margin-bottom: 10px; }\n\n  /* Dashboard tables */\n  .dashboard-header { gap: 8px; }\n  .data-table th, .data-table td { padding: 10px 12px; font-size: 13px; }\n\n  /* Tools */\n  .tools-grid { grid-template-columns: repeat(3, 1fr); gap: 10px; }\n  .tool-card { padding: 14px 6px; }\n  .tool-name { font-size: 10px; }\n\n  /* Steps */\n  .step-card { padding: 24px 16px; }\n\n  /* Testimonials */\n  .testimonial-card { padding: 24px 16px; }\n\n  /* Notif dropdown */\n  .notif-dropdown { width: 260px; }\n\n  /* Sidebar user area */\n  .sidebar-user-name { font-size: 12px; }\n\n  /* Badge */\n  .badge { font-size: 11px; padding: 4px 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
